import React, { useState, useEffect } from 'react';
import GenericStatTable from './GenericStatTable';
import { useSelector } from 'react-redux';

const SaleStatisticsTable = ({
                               statisticType,
                               tableRows = [],
                               mainColumns = [],
                               currency = '',
                               tableRowsRaw = [],
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(4);
  const filter = useSelector(state => state.saleFiltersSlice);

  useEffect(() => {
    setPage(0);
  }, [filter]);

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  return (
    <GenericStatTable
      columns={mainColumns}
      rows={tableRows}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={(p) => setPage(p)}
      onRowsPerPageChange={handleRowsPerPageChange}
      tableRowsRaw={tableRowsRaw}
      currency={currency}
      statisticType={statisticType}
      noDataMessage={'statistic.noData'}
    />
  );
};

export default React.memo(SaleStatisticsTable);
